import { render, staticRenderFns } from "./bindMM.vue?vue&type=template&id=5cedc288&scoped=true"
import script from "./bindMM.vue?vue&type=script&lang=js"
export * from "./bindMM.vue?vue&type=script&lang=js"
import style0 from "./bindMM.vue?vue&type=style&index=0&id=5cedc288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cedc288",
  null
  
)

export default component.exports